// extracted by mini-css-extract-plugin
module.exports = {"socialmedia":"contactPage_socialmedia__2TpLQ","section":"contactPage_section__3tkLk","tag":"contactPage_tag__3F9o_"};